import {domReady} from "./tools/domReady";
import {slider_gallery, slider_review} from "./components/sliders";
import {heights} from "./tools/heights";
import {resize} from "./tools/resize";
import {video_btn} from "./components/video";
import {tabs} from "./components/tabs";
import {appears} from "./tools/appears";
import {counter} from "./components/counter";
import {applyMatchHeight, matchHeight} from "./tools/matchheight";
import {modal} from "./components/modal";
import {comment_field, date_field} from "./components/form";

domReady(async() => {
  slider_review();
  slider_gallery();
  modal();
  heights();

  matchHeight(
    '.advantages__item .content',
    '.reviews__item blockquote'
  )

  resize(
    heights,
    applyMatchHeight
  )

  video_btn();
  tabs();
  getScrollPosition();
  appears('.animation');
  counter();
  date_field();
  comment_field();

  document.querySelectorAll('input[type=tel]').forEach(inputField => {
    inputField.addEventListener('keydown', function(event) {
      const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];

      // Always allow control keys
      if (allowedKeys.includes(event.key)) {
        return;
      }

      // Handle + sign - only allowed as first character
      if (event.key === '+') {
        if (this.selectionStart !== 0 || this.value.includes('+')) {
          event.preventDefault();
        }
        return;
      }

      // Handle space - only allowed between numbers, not at the end
      if (event.key === ' ') {
        const cursorPos = this.selectionStart;
        const valueBeforeCursor = this.value.substring(0, cursorPos);
        const valueAfterCursor = this.value.substring(cursorPos);

        // Check if there's a digit before and after the cursor position
        const hasDigitBefore = /\d$/.test(valueBeforeCursor);
        const hasDigitAfter = /^\d/.test(valueAfterCursor);

        if (!hasDigitBefore || !hasDigitAfter) {
          event.preventDefault();
        }
        return;
      }

      // Prevent any other key
      event.preventDefault();
    });
  })
});

// scroll top menu
let scrollObject = {};
window.onscroll = getScrollPosition;
const main = document.getElementById('header');
function getScrollPosition(){
		scrollObject = {
			 x: window.pageXOffset,
			 y: window.pageYOffset
		}
		if( scrollObject.y > 120 ) {
				main.classList.add('is-active');
		} else {
				main.classList.remove('is-active');
		}
}

// Nav mobile
const body = document.body;
const navicon = document.getElementById('navicon');
const nav = document.getElementById('main-nav');

navicon.onclick = function () {
	if (navicon.classList.contains('active')) {
		navicon.classList.replace('active', 'passive');
		body.classList.toggle('nav-open');
		nav.classList.toggle('active');
	} else {
		navicon.classList.replace('passive', 'active');
		body.classList.toggle('nav-open');
		nav.classList.toggle('active');
	}
}

const btnMenu = nav.querySelectorAll('a');
btnMenu.forEach( btn => {
	btn.addEventListener('click', (e) => {
		nav.classList.remove('active')
		body.classList.remove('nav-open')
		navicon.classList.replace('active', 'passive')
	});
})
